import React, { useEffect} from "react";
import "../Styles/About.scss";
import heroImg from "../Image/img14.JPG";
import img1 from "../Image/img42.JPG";
import img2 from "../Image/img25.JPG";
import { Link } from "react-router-dom";

const About = () => {
  // const [fadeSections, setFadeSections] = useState({});

  // Scroll-triggered fade-in
  useEffect(() => {
    const sections = document.querySelectorAll(".fade-section");

    const handleScroll = () => {
      sections.forEach((section) => {
        const rect = section.getBoundingClientRect();
        if (rect.top < window.innerHeight - 100) {
          section.classList.add("visible");
        }
      });
    };

    window.addEventListener("scroll", handleScroll);
    handleScroll(); // trigger on mount
    return () => window.removeEventListener("scroll", handleScroll);
  }, []);

  const scrollToTop = () => {
    window.scrollTo ({
      top: 0,
      behavior: "smooth",
    });
  };

  return (
    <div className="about-page">
      {/* HERO */}
      <section
        className="hero-section fade-section"
        style={{ backgroundImage: `url(${heroImg})` }}
      >
        <div className="overlay" />
        <div className="hero-text">
          <h1>KURTI HOTEL</h1>
          <p>
            Where elegance meets serenity. Indulge in a world of luxury designed
            to awaken your senses and elevate your spirit.
          </p>
         <Link to="/contact"> <button className="contact-btn" onClick={scrollToTop} >Contact Us</button></Link>
        </div>
      </section>

      {/* PHILOSOPHY */}
      <section className="philosophy-section fade-section">
        <div className="container">
          <h2>Our Philosophy</h2>
          <p>
            Luxury is not an indulgence at Kurti Hotel; it is a philosophy. Every
            corner, every detail, every service is designed to create moments that
            linger in memory. Sophistication, refinement, and comfort converge here.
          </p>
        </div>
      </section>

      {/* STAY EXPERIENCE */}
      <section className="experience-section fade-section">
        <div className="experience-container">
          <div className="text">
            <h2>The Ultimate Stay</h2>
            <p>
              Our rooms are sanctuaries of comfort and style. Sumptuous linens,
              panoramic views, and elegant décor combine to provide an unparalleled
              escape from the ordinary.
            </p>
           <Link to="/rooms" > <button className="contact-btn" onClick={scrollToTop} >Our Rooms</button></Link>
          </div>
          <div className="images">
            <div className="img-wrapper">
              <img src={img1} alt="Luxury Room" />
            </div>
            <div className="img-wrapper">
              <img src={img2} alt="Hotel Interior" />
            </div>
          </div>
        </div>
      </section>

      {/* HOSPITALITY */}
      <section className="hospitality-section fade-section">
        <div className="container">
          <h2>Unmatched Hospitality</h2>
          <p>
            Our team blends warmth, professionalism, and discretion, ensuring
            that each guest experiences a seamless and memorable stay. From
            personalized attention to curated experiences, excellence is our
            promise.
          </p>
        </div>
      </section>

      {/* CTA */}
      <section className="cta-section fade-section">
        <div className="container">
          <h2>Begin Your Kurti Experience</h2>
          <p>
            Reach out today and let us craft an unforgettable stay tailored just for you.
          </p>
         <Link to="/contact" ><button className="contact-btn" onClick={scrollToTop} >Contact Us</button></Link> 
        </div>
      </section>
    </div>
  );
};

export default About;
